module.exports = __webpack_public_path__ + "img/mobile_payments.5cedff9d.png";